export default function TimerBar({ timeLeft, timerMax }) {
  const pct     = timerMax > 0 ? (timeLeft / timerMax) * 100 : 0
  const urgent  = pct < 30
  const warning = pct < 60
  const color   = urgent ? 'bg-red-500' : warning ? 'bg-orange-400' : 'bg-green-500'
  return (
    <div className="w-full h-3 bg-white/10 rounded-full overflow-hidden">
      <div className={`h-full rounded-full transition-all duration-1000 ${color}`} style={{ width: `${pct}%` }} />
    </div>
  )
}
